import ApiService from "@/plugins/ApiService";
import { SET_PLANS, SET_INVOICES, SET_LOADING } from "@/store/mutation-types";
import { FETCH_PLANS, FETCH_INVOICES, DISPATCH_UPGRADE } from "@/store/action-types";

const state = {
    plans: {},
    invoices: [],
}

const mutations = {

    [SET_PLANS](state, data) {
        state.plans = data
    },

    [SET_INVOICES](state, data) {
        state.invoices = data

    }
}


const actions = {

    [FETCH_PLANS]: async({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            ApiService.query(`settings/plans/${payload.id}`)
                .then((response) => {

                    commit(SET_LOADING, false)
                    commit(SET_PLANS, response.data)
                    resolve(response.data)

                })
                .catch((e) => {
                    commit(SET_LOADING, false)
                    reject(e)
                })
        })

    },

    [FETCH_INVOICES]: async({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            ApiService.query(`settings/invoices/${payload.id}`)
                .then((response) => {

                    commit(SET_LOADING, false)
                    commit(SET_INVOICES, response.data)
                    resolve(response.data)

                })
                .catch((e) => {
                    commit(SET_LOADING, false)
                    reject(e)
                })
        })

    },


    [DISPATCH_UPGRADE]: async({ commit }, payload) => {
        try {
            commit(SET_LOADING, true)
            await ApiService.post('settings/upgrade', payload)
            commit(SET_LOADING, false)

        } catch (error) {
            commit(SET_LOADING, false)
                //throw error
        }
    },

}

export default {
    state,
    mutations,
    actions
}